import tw, { styled } from 'twin.macro';

export const MobileModalContainer = styled.div`
  ${tw`fixed w-full bg-white flex flex-col -bottom-full`};
  box-shadow: 0 0 20px rgba(34, 36, 38, 0.15);
  transition: bottom 0.7s ease;
  z-index: 2000;
  height: 90%;

  &.sidebar-modal {
    ${tw`h-1/2`};
  }
  
  &.active {
    ${tw`bottom-0`};
  }
`;

export const MobileModalOverlay = styled.div`
  ${tw`fixed top-0 w-full h-full max-h-full m-0 overflow-hidden bg-gray-800 cursor-pointer bg-opacity-20`};
  z-index: 2000;
`;

export const MobileModalWrapper = styled.div`
  ${tw`relative h-full bg-white w-full lg:hidden`};
`;

export const MobileModalBody = styled.div`
  ${tw`h-full w-full overflow-y-auto`};
  &::-webkit-scrollbar {
    background-color: #f5f5f5;
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    ${tw`bg-fplsBlue rounded-2xl`};
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    ${tw`bg-fplsBlue rounded-2xl`};
    background-color: #f5f5f5;
  }
`;

export const CloseButton = styled.button`
  ${tw`p-2 text-xl absolute text-white left-0 flex justify-center items-center border-none bg-fplsBlue w-8 h-8 -top-8`};
`;

// Config
export const desktopModalStyles = {
  large: {
    backgroundColor: '#00a0c6',
    maxWidth: '800px',
    height: '600px',
    borderRadius: 0,
  },
  medium: {
    backgroundColor: '#28879d',
    padding: '15px 0px',
    maxWidth: '800px',
    height: '500px',
  },
  small: {
    maxWidth: '600px',
    height: '380px',
  },
  mini: {
    maxWidth: '500px',
    height: '580px',
  }
};